import React from "react";
import TuiImageEditor from "tui-image-editor";

import "tui-image-editor/dist/tui-image-editor.css";
import "tui-color-picker/dist/tui-color-picker.css";
import colorPicker from "tui-color-picker";
import "./font.css";
import "./style.css";
import { fabric } from "fabric";

class ImageEditor extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      gridlines: false,
    };
    this.state = {
      selectedFormat: "png",
    };
    this.rootEl = React.createRef();
    this.imageEditorInst = null;
    this.TUI_selectedItem = null;
    this.TUI_selectedFont = null;
  }

  componentDidMount() {
    this.imageEditorInst = new TuiImageEditor(this.rootEl.current, {
      ...this.props,
    });

    // Keep track of active/selected item
    this.imageEditorInst.on("objectActivated", (props) => {
      this.TUI_selectedItem = props;
      this.TUI_updateFontSelected(props);
    });

    // Add Color Picker
    const container = document.createElement("div");
    const picker = colorPicker.create({
      container: container,
      color: "#000000",
    });

    let textMenu = document.querySelector(".tie-text-color.tui-image-editor-button");
    textMenu.parentNode.appendChild(container);

    picker.on("selectColor", (event) => {
      if (this.TUI_selectedItem) {
        this.imageEditorInst.changeTextStyle(this.TUI_selectedItem.id, {
          fill: event.color,
        });
      }
    });

    // Font select list
    let fontArray = ["NunitoSans-Regular", "Noto Sans"];
    let fontSelectHTML = '<select class="form-select font-selector">';
    for (let i = 0; i < fontArray.length; i++) {
      let selected = "";
      if (i == 0) {
        selected = "selected";
      }
      fontSelectHTML += '<option style="font-family:' + fontArray[i] + ';" value="' + fontArray[i] + '" ' + selected + ">" + fontArray[i] + "</option>";
    }
    fontSelectHTML += "</select>";

    let textMenuAlign = document.querySelector(".tui-image-editor-menu-text .tie-text-effect-button");
    // let textMenuAlign = document.querySelector(".tui-image-editor-menu-text .tie-text-align-button");
    textMenuAlign.insertAdjacentHTML("afterbegin", fontSelectHTML);

    // Add event listener to font selector
    document.querySelector(".font-selector").addEventListener("change", (event) => {
      this.TUI_updateFontOnText(event.target.value);
    });

    let textMenuButtons = document.querySelector(".tui-image-editor-menu-text .tie-text-align-button");

    // Crie o botão "Vertical Center"
    const verticalCenterButton = document.createElement("button");
    verticalCenterButton.className = "vertical-center-text-button";
    verticalCenterButton.textContent = "Vertical Center";

    // Crie o botão "Horizontal Center"
    const horizontalCenterButton = document.createElement("button");
    horizontalCenterButton.className = "horizontal-center-text-button";
    horizontalCenterButton.textContent = "Horizontal Center";

    const buttonsContainer = document.createElement("div");
    buttonsContainer.className = "center-text-buttons";
    buttonsContainer.style.display = "flex"; // Adiciona flex container
    buttonsContainer.style.flexDirection = "column";
    buttonsContainer.appendChild(verticalCenterButton);
    buttonsContainer.appendChild(horizontalCenterButton);

    textMenuButtons.insertAdjacentElement("beforeend", buttonsContainer);
    // Add center text button
    // let verticalCenterButtonHTML = '<button class="vertical-center-text-button">Vertical Center</button>';
    // textMenuButtons.insertAdjacentHTML("afterbegin", verticalCenterButtonHTML);

    // let horizontalCenterButtonHTML = '<button class="horizontal-center-text-button">Horizontal Center</button>';
    // textMenuButtons.insertAdjacentHTML("afterbegin", horizontalCenterButtonHTML);

    document.querySelector(".vertical-center-text-button").addEventListener("click", () => {
      this.verticalCenterText();
    });

    document.querySelector(".horizontal-center-text-button").addEventListener("click", () => {
      this.horizontalCenterText();
    });

    // Create gridlines logic and button
    const toggleGridlinesButton = document.createElement("button");
    toggleGridlinesButton.className = "toggle-gridlines-button";
    toggleGridlinesButton.textContent = "Toggle Gridlines";

    textMenuAlign.insertAdjacentElement("beforeend", toggleGridlinesButton);

    document.querySelector(".toggle-gridlines-button").addEventListener("click", () => {
      this.toggleGridLines();
    });

    // Add save button to menu
    const ulHelpMenu = document.querySelector(".tui-image-editor-help-menu.top");

    const liSave = document.createElement("li");
    liSave.classList.add("tui-image-editor-item", "help");

    // Set the styles of the list item
    // liSave.style.width = "100px";
    liSave.style.height = "45px";
    liSave.style.borderRadius = "8px";
    liSave.style.color = "#fff";
    liSave.style.backgroundColor = "#1462A5";
    liSave.style.boxShadow = "0px 1px 2px 0px rgba(16, 24, 40, 0.05)";
    // liSave.style.textTransform = "capitalize";
    liSave.style.fontSize = "16px";
    liSave.style.fontWeight = "400";

    // Add hover effect
    liSave.onmouseover = function () {
      this.style.backgroundColor = "#124572";
    };
    liSave.onmouseout = function () {
      this.style.backgroundColor = "#1462A5";
    };

    liSave.textContent = "Concluir e baixar imagem";

    liSave.addEventListener("click", () => {
      if (this.state.gridlines) {
        this.toggleGridLines();
      }
      const dataUrl = this.imageEditorInst.toDataURL();

      const a = document.createElement("a");

      a.href = dataUrl;
      a.download = `edited-image.${this.state.selectedFormat}`;

      a.click();
    });

    // Add format dropdown to menu
    const liFormats = document.createElement("li");
    liFormats.classList.add("tui-image-editor-item", "help");

    const selectElement = document.createElement("Select");
    selectElement.value = this.state.selectedFormat;
    selectElement.addEventListener("change", this.handleChangeFormat);

    selectElement.style.height = "45px";
    selectElement.style.borderRadius = "8px";
    selectElement.style.marginBottom = "5px";
    selectElement.style.color = "rgba(20, 97, 164, 1)";
    selectElement.style.backgroundColor = "rgba(255, 255, 255, 1)";
    selectElement.style.fontSize = "16px";
    selectElement.style.fontWeight = "400";
    selectElement.style.boxShadow = "0px 1px 2px 0px rgba(16, 24, 40, 0.05)";

    selectElement.addEventListener("mouseenter", function () {
      this.style.backgroundColor = "rgba(20, 97, 164, 1)";
      this.style.color = "rgba(255, 255, 255, 1)";
    });

    selectElement.addEventListener("mouseleave", function () {
      this.style.backgroundColor = "rgba(255, 255, 255, 1)";
      this.style.color = "rgba(20, 97, 164, 1)";
    });

    const options = [
      { value: "png", label: "PNG" },
      { value: "webp", label: "WebP" },
    ];

    options.forEach((option) => {
      const optionElement = document.createElement("option");
      optionElement.value = option.value;
      optionElement.text = option.label;
      selectElement.appendChild(optionElement);
    });

    liFormats.appendChild(selectElement);

    ulHelpMenu.appendChild(liSave);
    ulHelpMenu.appendChild(liFormats);
  }

  componentWillUnmount() {
    this.imageEditorInst.destroy();
    this.imageEditorInst = null;
  }

  handleChangeFormat = (event) => {
    this.setState({ selectedFormat: event.target.value });
  };

  TUI_updateFontOnText(font) {
    if (font) {
      this.TUI_selectedFont = font;
    }

    if (font && this.TUI_selectedItem) {
      this.imageEditorInst.changeTextStyle(this.TUI_selectedItem.id, {
        fontFamily: font,
      });
    }
  }

  TUI_updateFontSelected(layer) {
    if ((layer.type === "text" || layer.type === "i-text") && layer.fontFamily) {
      document.querySelector(".font-selector").value = layer.fontFamily;
      this.TUI_selectedFont = layer.fontFamily;
    }
  }

  verticalCenterText() {
    if (this.TUI_selectedItem && (this.TUI_selectedItem.type === "text" || this.TUI_selectedItem.type === "i-text")) {
      const canvasSize = this.imageEditorInst.getCanvasSize();
      this.imageEditorInst.setObjectPosition(this.TUI_selectedItem.id, {
        y: canvasSize.height / 2,
        x: this.imageEditorInst.getObjectPosition(this.TUI_selectedItem.id, "left", "top").x,
        originY: "bottom",
        originX: "center",
      });
    }
  }

  horizontalCenterText() {
    if (this.TUI_selectedItem && (this.TUI_selectedItem.type === "text" || this.TUI_selectedItem.type === "i-text")) {
      const canvasSize = this.imageEditorInst.getCanvasSize();
      this.imageEditorInst.setObjectPosition(this.TUI_selectedItem.id, {
        x: canvasSize.width / 2,
        y: this.imageEditorInst.getObjectPosition(this.TUI_selectedItem.id, "left", "top").y,
        originX: "right",
        originY: "center",
      });
    }
  }

  toggleGridLines = () => {
    if (this.state.gridlines) {
      // If the gridlines are currently displayed, remove them
      const objects = this.imageEditorInst._graphics.getCanvas().getObjects("line");
      for (let i in objects) {
        this.imageEditorInst._graphics.getCanvas().remove(objects[i]);
      }
      this.setState({ gridlines: false });
    } else {
      // If the gridlines are not currently displayed, draw them on the image
      this.drawGridLines();
      this.setState({ gridlines: true });
    }
    this.imageEditorInst._graphics.getCanvas().renderAll();
  };

  drawGridLines = () => {
    const canvas = this.imageEditorInst._graphics.getCanvas();

    // Calculate the grid size (this example uses a 100x100px grid)
    const gridSize = 30;
    // const gridSize = Math.min(canvas.getWidth(), canvas.getHeight()) / 6;

    // Calculate the number of vertical and horizontal lines
    const verticalLines = Math.ceil(canvas.getWidth() / gridSize);
    const horizontalLines = Math.ceil(canvas.getHeight() / gridSize);

    // Draw the vertical lines
    for (let i = 0; i <= verticalLines; i++) {
      const line = new fabric.Line([i * gridSize, 0, i * gridSize, canvas.getHeight()], {
        stroke: "red",
        strokeWidth: 1,
        selectable: false,
        evented: false,
      });
      canvas.add(line);
    }

    // Draw the horizontal lines
    for (let i = 0; i <= horizontalLines; i++) {
      const line = new fabric.Line([0, i * gridSize, canvas.getWidth(), i * gridSize], {
        stroke: "red",
        strokeWidth: 1,
        selectable: false,
        evented: false,
      });
      canvas.add(line);
    }

    canvas.renderAll();
  };

  render() {
    return (
      <div>
        <div ref={this.rootEl} />
      </div>
    );
  }
}

export default ImageEditor;
